<template>
  <div>
    <b-card-group deck align="center">
      <b-card style="max-width: 20rem;">
      <b-card-text>
        <b-input-group class="mt-3">
          <b-form-input :disabled="sendEmailDisabled" v-model="form.email" placeholder="Email/Имя входа"></b-form-input>
          <b-input-group-append>
            <b-button @click.prevent.stop="reset_pass" :disabled="sendEmailDisabled">Получить код</b-button>
          </b-input-group-append>
        </b-input-group>

        <b-input-group class="mt-3">
          <b-form-input v-if="inputToken" :disabled="sendTokenDisabled" v-model="token" placeholder="Код"></b-form-input>
          <b-input-group-append>
            <b-button v-if="inputToken" :disabled="sendTokenDisabled" @click.stop.prevent="send_token">Ввести код</b-button>
          </b-input-group-append>
        </b-input-group>
        <b-form-valid-feedback :state="sendEmailDisabled">
          Код выслан на ваш email. Повторите попытку если код не будет получен в течении двух минут.
        </b-form-valid-feedback>
      </b-card-text>
      </b-card>
    </b-card-group>




<!--    <b-form @submit.prevent="send_token" v-if="inputToken">-->
<!--      -->
<!--    </b-form>-->
  </div>
</template>

<script>
export default {
  name: "PassRestore",
  data() {
    return {
      form: {
        email: "",
      },
      token: "",
      showError: false,
      sendEmailDisabled: false,
      sendTokenDisabled: false,
      inputToken: false
    };
  },
  methods: {
    reset_pass: function (){
      if (this.form.email !== '') {
        this.sendEmailDisabled = true;
        this.inputToken = true;
        this.$store.dispatch('passRestore', {'username': this.form.email});
      }
    },
    send_token: function (){
      this.sendTokenDisabled = true;
      this.$store.dispatch('passRestore',{'username': this.form.email, 'token': this.token});
    }
  },
}
</script>

<style scoped>

</style>